import React from "react";
import {
  Page,
  MacProfiList,
  BreadCrumbs,
  RepairAppleLinksBanner,
  Section,
  RepairAppleLinksText,
  RepairIphoneModelLink,
  SelectForIphoneServiceLinks,
  RepairIpadModelLinksForServiceMobile,
} from "../index";
import banner from "../../images/banners/repair-ipadBattery.jpeg";
import { iPadListOfModelsForBattery } from "../../utils/ipadModels";
import { Helmet } from "react-helmet";

const textServiceLinkBattery = [
  {
    id: 1,
    title: "Особенности замены аккумулятора на iPad",
    text: 'Конечно, вы можете попытаться совершить данную операцию самостоятельно, но без особого сгущения красок, мы должны предупредить - скорее всего, подобные действия навредят вашему планшету еще больше. Даже при удачном стечении обстоятельств, самостоятельная замена батареи iPad, в сравнении с обращением к специалистам, не только заберёт у вас бесценные нервы, но и обойдётся гораздо дороже в пересчёте на "кровные". Один только список нужного инструмента: целый ряд приблуд с приставкой i- (медиаторы iFixit, грелка iOpener), присоски, пинцеты и специальные отвёртки, для которых в "домашнем хозяйстве" не найдётся никакого другого применения - способен внушить не малый трепет вашему семейному бюджету. А в придачу к этому ещё надо найти где-то золотые руки (не сомневаемся - ваши именно таковы), да ещё и многолетний опыт подобных операций (а вот этого у вас, наверняка, нет). Одним словом - проще, надёжнее и дешевле обратится за заменой аккумулятора на айпаде к специалистам. Таким как наши - у них и руки растут откуда надо, и весь необходимый профессиональный инструмент под рукой, да и рука набита многолетним опытом.',
  },
  {
    id: 2,
    title: "Почему может понадобится замена аккумулятора iPad?",
    text: (
      <>
        <p className="repair-iphone-display__paragraph">
          Во-первых, бесконечный аккумулятор пока, к сожалению, не изобретён.
          Даже прославленные Apple, тут пока ничего поделать не могут, и рано
          или поздно, но батарея вашего Айпэда начнёт терять ёмкость и потребует
          своей замены. Сократить жизнь аккумулятора могут и скачки напряжения в
          сети, и резкие перепады температуры (а это как раз характеризует наш,
          русский, климат).
        </p>
        <p className="repair-iphone-display__paragraph">
          Во-вторых, как и другие составляющие iPad, его батарея не переносит
          попадания влаги. Результат - окисление, и неизбежность замены
          аккумулятора iPad.
        </p>
      </>
    ),
  },
];

const optionsIpadBattery = [
  { value: "iPad", label: "iPad", price: "2400" },
  { value: "iPad 2", label: "iPad 2", price: "1900" },
  { value: "iPad 3", label: "iPad 3", price: "1600" },
  { value: "iPad 4", label: "iPad 4", price: "1900" },
  { value: "iPad mini", label: "iPad mini", price: "1900" },
  { value: "iPad Air", label: "iPad Air", price: "1900" },
  { value: "iPad mini 2", label: "iPad mini 2", price: "2350" },
  { value: "iPad Air 2", label: "iPad Air 2", price: "2350" },
  { value: "iPad mini 3", label: "iPad mini 3", price: "2500" },
  { value: "iPad Pro 12.9", label: "iPad Pro 12.9", price: "1900" },
  { value: "iPad mini 4", label: "iPad mini 4", price: "2080" },
  { value: "iPad Pro 9.7", label: "iPad Pro 9.7", price: "4450" },
  { value: "iPad 5", label: "iPad 5", price: "1900" },
  { value: "iPad Pro 2 10.5", label: "iPad Pro 2 10.5", price: "1900" },
  { value: "iPad Pro 2 12.9", label: "iPad Pro 2 12.9", price: "1900" },
  { value: "iPad 6 (2018)", label: "iPad 6 (2018)", price: "1900" },
  { value: "iPad Pro 11 (2018)", label: "iPad Pro 11 (2018)", price: "1900" },
  {
    value: "iPad Pro 12.9 (2018)",
    label: "iPad Pro 12.9 (2018)",
    price: "1900",
  },
  { value: "iPad Air 3 (2019)", label: "iPad Air 3 (2019)", price: "1600" },
  { value: "iPad mini 5", label: "iPad mini 5", price: "1900" },
  { value: "iPad 7", label: "iPad 7", price: "1900" },
  { value: "iPad 8", label: "iPad 8", price: "1900" },
  { value: "iPad Air 4 (2020)", label: "iPad Air 4 (2020)", price: "1900" },
  { value: "iPad Pro 11 (2021)", label: "iPad Pro 11 (2021)", price: "1900" },
  {
    value: "iPad Pro 12.9 (2021)",
    label: "iPad Pro 12.9 (2021)",
    price: "1900",
  },
  { value: "iPad 9", label: "iPad 9", price: "1900" },
  { value: "iPad mini 6", label: "iPad mini 6", price: "1900" },
];

const RepairIpadServiceLinkBattery = () => {
  return (
    <Page title="Замена аккумулятора iPad в Москве, цены на замену аккумулятора Айпад">
      <main className="repair-iphone-group-content">
        <Helmet>
          <link
            rel="canonical"
            href="https://ohmygadget.ru/remont-apple/remont-ipad/zamena-akkumuljatora"
          />
          <meta charSet="utf-8" />
          <meta
            name="description"
            content="Выполняем замену аккумулятора iPad в кратчайшие сроки, низкие цены, бесплатная доставка в сц."
          />
        </Helmet>
        <MacProfiList />
        <BreadCrumbs />
        <RepairAppleLinksBanner
          banner={banner}
          title="Замена аккумулятора iPad в Москве"
          alt="замена аккумулятора iPad"
          titleImg="замена аккумулятора iPad"
          text="Ваш iPad стал разряжаться горазда быстрее, чем обычно - полноценного заряда не хватает даже на день умеренного интернет-сёрфа или другого использования планшета по назначению? Или же он отказывает заряжаться вообще? Тогда вам необходима замена аккумулятора iPad."
        />
        <Section
          className="section_group"
          style={{
            backgroundColor: "rgba(196, 196, 196, 0.09)",
            width: "100%",
            padding: "55px 0 105px",
            marginTop: 55,
          }}
        >
          <div className="repair-mb__group-list-container">
            <h2 className="repair-mb__group-links-subtitle">
              Цены на замену аккумулятора iPad
            </h2>
            <SelectForIphoneServiceLinks
              options={optionsIpadBattery}
              text="аккумулятора"
            />
          </div>
        </Section>
        <Section className="section_group" style={{ padding: "50px 0 65px" }}>
          {textServiceLinkBattery.map((item) => {
            return <RepairAppleLinksText key={item.id} {...item} />;
          })}
        </Section>
        {/* <RepairIphoneModelLink
          heading="Мы также производим замену:"
          links={iPadListOfModelsForBattery}
        /> */}
        <RepairIpadModelLinksForServiceMobile
          links={iPadListOfModelsForBattery}
        />
      </main>
    </Page>
  );
};

export default RepairIpadServiceLinkBattery;
